module.exports = "pegasus/assets/themelp1/creative/105.png";